import { ModalStyled } from "./styles";
import { ModalProps } from "./types";

export const Modal = ({ title, open, onCancel, footer, width, children }: ModalProps) => {
  return (
    <ModalStyled
      title={title}
      centered
      closable
      open={open}
      onCancel={() => onCancel()}
      footer={footer}
      width={width}
    >
      {children}
    </ModalStyled>
  )
}

export default Modal;